import { createSelector } from '@reduxjs/toolkit'

import { selectDownloadStatus } from './selectDownloadStatus'

export const selectIsDownloading = createSelector(
  selectDownloadStatus,
  (status) => status === 'starting' || status === 'downloading'
)
